export default __webpack_public_path__ + "static/tiktok-42931dfa55268e5496d954ea5d81ccae.svg";